module.exports = __webpack_public_path__ + "static/media/pf10.311a19f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf10.png
// module id = 2654
// module chunks = 0